/* eslint-disable */
/* eslint-disable react/forbid-prop-types */
import React from 'react'
import PropTypes from 'prop-types'
import EpubReader from '@minha-biblioteca/epub-reader'
import { getSessionToken, getApplicationToken } from '../../auth'
import Users from '../../services/accounts/users'
import { toCamelCase } from '../../utils'
import ErrorBoundary from './ErrorBoundary'
import { useHistory } from 'react-router-dom'

const bookTitleFromSearch = (search) => {
  if (!search) return ''

  const normalizedSearch = search.startsWith('?') ? search.substring(1) : search
  const params = new URLSearchParams(normalizedSearch)
  const title = params.get('title')

  if (!title) return ''

  return toCamelCase(title)
}

export default function Reader({ history, match }) {
  const { uuid } = match.params
  const { search } = history.location
  history = useHistory()
  const { goBack } = history

  return (
    <ErrorBoundary>
      <EpubReader
        bookTitle={bookTitleFromSearch(search)}
        uuid={uuid}
        userId={Users.getUserId()}
        applicationToken={getApplicationToken()}
        sessionToken={getSessionToken()}
        backToBds={() => goBack()}
        integrationType={Users.getIntegrationType()}
      />
    </ErrorBoundary>
  )
}

Reader.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
}
